export const contactEmail =
  process.env.REACT_APP_CONTACT_EMAIL || "contact@fatihoune.com";

export const whatsappNumber =
  process.env.REACT_APP_WHATSAPP_NUMBER || "";

export const whatsappLabel =
  process.env.REACT_APP_WHATSAPP_LABEL || "WhatsApp";

export const defaultWhatsAppMessage =
  "Bonjour Fatihoune, je souhaite avoir des informations sur vos services.";

export function getWhatsAppHref(message = defaultWhatsAppMessage) {
  const number = whatsappNumber.replace(/\D/g, "");
  const encodedMessage = encodeURIComponent(message);

  if (!number) {
    return `https://wa.me/?text=${encodedMessage}`;
  }

  return `https://wa.me/${number}?text=${encodedMessage}`;
}
